// src/services/FieldGroupService.js

import http from './http';

const unwrap = (response) => {
  const envelope = response?.data;
  if (!envelope || envelope.code !== 200) {
    throw new Error(envelope?.message || envelope?.status || 'Request failed');
  }
  return envelope.data;
};

const FieldGroupService = {
  /**
   * Get table descriptor by id
   * @param {string} fieldId - The table descriptor id
   * @returns {Promise<Object|null>} - Returns table descriptor object with is_pages_hyper_link and url fields
   */
  getTableDescriptorById: async (fieldId) => {
    try {
      const response = await http.GET(`field-groups/table-descriptor/${fieldId}`);
      if (response.status === 200 && response.data) {
        const responseData = response.data;
        if (responseData.code === 200 && responseData.data) {
          return responseData.data;
        }
      }
      return null;
    } catch (error) {
      console.error('Error fetching table descriptor:', error);
      return null;
    }
  },

  /** GET field-groups/window/related-windows — same as Reports `generateWindowFields`. */
  fetchRelatedWindows: async () => {
    const response = await http.GET('field-groups/window/related-windows');
    return unwrap(response);
  },

  /**
   * POST field-groups/window/related-windows/fields — same as Reports `callReportPreview`.
   * @param {{ window_id: string, related_window: Array, table_descriptor_ids?: string[] }} windowInfo
   */
  fetchRelatedWindowFields: async (windowInfo) => {
    const body = {
      window_info: {
        window_id: windowInfo.window_id,
        related_window: windowInfo.related_window || [],
      },
    };
    if (windowInfo.table_descriptor_ids?.length) {
      body.table_descriptor_ids = windowInfo.table_descriptor_ids;
    }
    const response = await http.POST('field-groups/window/related-windows/fields', body);
    return unwrap(response);
  },
};

export default FieldGroupService;

